<template>
  <div class="view-content">
    <div class="search-box">
      <el-form :model="search" :inline="true" ref="searchFrom" size="small">
        <el-form-item label="名称:" prop="searchName">
          <el-input v-model="search.searchName" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="结算月份:" prop="month">
          <el-date-picker
            v-model="search.month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="订单状态:" prop="orderStatus">
          <el-select v-model="search.orderStatus" placeholder="订单状态">
            <el-option
              v-for="(item, index) in orderStatusList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" size="small"
            >搜索</el-button
          >
          <el-button @click="handleReset" size="small">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="600"
      size="small"
      :header-cell-style="{
        background: '#f5f5f5',
        color: '#000',
        fontWeight: 'bold',
        align: 'center',
      }"
    >
      <el-table-column
        prop="qrName"
        label="二维码名称"
        width="180"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="qrcodeNo"
        label="二维码编号"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单编号"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="categoryName"
        label="服务项目名称"
        width="150"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column prop="orderMoney" label="订单金额" align="center">
      </el-table-column>
      <el-table-column prop="orderStatus" label="订单状态" align="center">
        <template slot-scope="scope">
          <span style="font-weight: bold">
            {{ getStatus(scope.row.orderStatus) }}</span
          >
        </template>
      </el-table-column>

      <el-table-column prop="payStatus" label="支付状态" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.payStatus == 1">
            已支付
          </el-tag>
          <el-tag type="danger" v-if="scope.row.payStatus == 0">
            未支付
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center">
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        prev-text="上一页"
        next-text="下一页"
        :current-page.sync="search.pageIndex"
        :page-size.sync="search.pageSize"
        :page-sizes="[10, 30, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { GetChannelOrderList } from "@/api/order/index";
export default {
  name: "orderList",
  data() {
    return {
      search: {
        searchName: "",
        month: "",
        orderStatus: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      statusList: [
        "待支付",
        "待接单",
        "服务中",
        "待确认完成",
        "已完成",
        "已取消",
        "退款中",
        "已关闭",
        "已退款",
        "待派单",
        "待预约",
        "已接单",
      ],
      orderStatusList: [
        { label: "全部", value: 0 },
        { label: "待支付", value: 1 },
        { label: "服务中", value: 2 },
        { label: "已完成", value: 3 },
        { label: "已取消", value: 4 },
      ],
    };
  },
  mounted() {
    let now = new Date();
    let year = now.getFullYear();
    let month = String(now.getMonth() + 1).padStart(2, "0");
    this.search.month = `${year}-${month}`;
    this.getTableData();
  },
  methods: {
    getStatus(index) {
      return this.statusList[index] || "未知状态";
    },
    handleReset() {
      this.search = this.$options.data().search;
      this.getTableData();
    },
    handleSearch() {
      this.search.pageIndex = 1; // 搜索时重置页码
      this.getTableData();
    },
    handleSizeChange(val) {
      this.search.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.search.pageIndex = val;
      this.getTableData();
    },
    // 获取表格数据
    getTableData() {
      GetChannelOrderList(this.search).then((res) => {
        if (res.data.isSuccess) {
          this.tableData = res.data.data || [];
          this.total = res.data.total || 0;
        }
      });
    },
  },
};
</script>
<style scoped>
.img-box {
  width: 130px;
  height: 130px;
}
</style>
